import { SelectionHandler } from "../../types";
import { DesignationSelectionHandler } from "../ConstraintsLayerType/DesignationSelectionHandler";
import { TrafficSelectionDetailView } from "./TrafficSelectionDetailView";

export const TrafficSelectionHandler: SelectionHandler = {
  ...DesignationSelectionHandler,
  SelectionDetailView: TrafficSelectionDetailView,
};
